// extracted by mini-css-extract-plugin
export var description = "ParagraphSupportWidget-module--description--edf74";
export var inner = "ParagraphSupportWidget-module--inner--677a0";
export var title = "ParagraphSupportWidget-module--title--a9719";
export var titlenopadding = "ParagraphSupportWidget-module--titlenopadding--66e41";
export var widget = "ParagraphSupportWidget-module--widget--07c00";